
const businessIndexModule = {
    namespaced: true,
    state: {
        data: null,
        indexList: [
            {
                label: 'Абсолютная ликвидность',
                descr: 'Коэффициент, равный отношению денежных средств и краткосрочных финансовых вложений к краткосрочным обязательствам (текущим пассивам)',
                normalValue: '≥ 25',
                key: 'abs_liq',
                color: '#ff0000'
            },
            {
                label: 'Текущая ликвидность',
                descr: 'Коэффициент, равный отношению&nbsp;текущих&nbsp;(оборотных) активов к краткосрочным обязательствам (текущим&nbsp;пассивам)',
                normalValue: '≥ 200',
                key: 'teq_liq',
                color: '#0000ff'
            },
            {
                label: 'Восстановление платежеспособности',
                descr: 'Коэффициент, показывающий возможность восстановления нормальной текущей ликвидности предприятия в течение 6 месяц после отчетной даты.',
                normalValue: '≥ 100',
                key: 'vosst_platezh',
                color: '#ffbf00'
            },
            {
                label: 'Финансовая устойчивость',
                descr: 'Коэффициент, равный отношению собственного капитала и долгосрочных обязательств к валюте баланса.',
                normalValue: '≥ 50',
                key: 'fin_ustoych',
                color: '#ff00bf'
            },
            {
                label: 'Коэффициент маневренности',
                descr: 'Коэффициент, показывающий финансово-хозяйственную эффективность предприятия.',
                normalValue: '≥ 10',
                key: 'manevr',
                color: '#00a340'
            },
            {
                label: 'Автономность',
                descr: 'Коэффициент,  показывающий, какая часть активов образуется за счет собственного капитала, например, уставного капитала, нераспределенной прибыли.',
                normalValue: '≥ 50',
                key: 'avtonom',
                color: '#b366ff'
            },
            {
                label: 'Обеспеченность собственными оборотными средствами',
                descr: 'Коэффициент, отражающий долю собственных оборотных средств во всех оборотных активах предприятия.',
                normalValue: '≥ 50',
                key: 'obesp_sob_obor_sr',
                color: '#00ff00'
            },
            {
                label: 'Соотношение собственных и заемных средств',
                descr: 'Коэффициент,  служащий одним из экономических показателей и дающий общее представление о пропорции, которую составляют заемные и собственные средства юрлица.',
                normalValue: '≤ 70',
                key: 'sootn_sobstv_zaem_sr',
                color: '#00bfff'
            },
            {
                label: 'Коэффициент капитализации',
                descr: 'Коэффициент, сравнивающий размер долгосрочной кредиторской задолженности с совокупными источниками долгосрочного финансирования.',
                normalValue: '≤ 100',
                key: 'kapitaliz',
                color: '#663300'
            },
            {
                label: 'Коэффициент финансирования',
                descr: 'Коэффициент, определяющий на сколько собственные средства компании преобладают над привлеченными, или наоборот – есть ли наличие дефицита первых.',
                normalValue: '≥ 100',
                key: 'finansir',
                color: '#00ffcc'
            },
            {
                label: 'Налоговая нагрузка',
                descr: 'Средний коэффициент налоговой нагрузки.',
                normalValue: '≥ 11',
                key: 'taxes_weight',
                color: '#317184'
            },
            {
                label: 'Нагрузка по страховым взносам',
                descr: 'Средний коэффициент нагрузки по страховым взносам.',
                normalValue: '≥ 3.3',
                key: 'insurance_weight',
                color: '#d46004'
            },
        ]
    },
    actions: {
        getData({ dispatch, commit }, inn) {

            return dispatch('v3/API', {
                method: 'economics',
                data: {
                    action: 'business_coefficient',
                    inn
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit('setStateObject', { name: 'card.businessIndex.data', value: e.data?.data }, { root: true })
                }
            }).catch(err => {
                console.error(err.message)
            })
        }
    },
    getters: {
        years(state) {
            return state.data ? Object.keys(state.data) : []
        }
    }
}

export default businessIndexModule